// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsSpotAssignBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
  row: number;
  userId: string | null;
};

export type typeStripsSpotAssignOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    stripNumber: number;
    row: number;
    userId?: string | null;
    previousUserId?: string | null;
  };
};

export type typeStripsSpotAssignOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSpotAssignOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSpotAssignOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsSpotAssignBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
    row: { type: "integer" },
    userId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "eventId", "stripNumber", "row", "userId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsSpotAssign(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsSpotAssignBody);
  }

  return async function postStripsSpotAssign(
    payload: typeStripsSpotAssignBody,
  ): Promise<typeStripsSpotAssignOutput200 | typeStripsSpotAssignOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsSpotAssign" failed before calling the network. #99826af3bcf3`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#99826af3bcf3" },
        },
        data: null,
      } as typeStripsSpotAssignOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/spot-assign`,
      httpMethod: "POST",
      options,
    })) as typeStripsSpotAssignOutput200 | typeStripsSpotAssignOutput400;
  };
}
